enum IeTipoContrato {
  C = 'C',
  I = 'I',
}

export { IeTipoContrato };
